import { render, staticRenderFns } from "./LiveDataSchedule.vue?vue&type=template&id=064d58b3&scoped=true"
import script from "./LiveDataSchedule.vue?vue&type=script&lang=js"
export * from "./LiveDataSchedule.vue?vue&type=script&lang=js"
import style1 from "./LiveDataSchedule.vue?vue&type=style&index=1&id=064d58b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d58b3",
  null
  
)

export default component.exports